import { YhBox } from "@/erp_subpackage/components/YhBox";
import { YhFormBox } from "@/erp_subpackage/components/YhFormBox";
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum";
import { getFormValidatorErrText } from "@/erp_subpackage/utils/util";
import { Button, message } from "antd";
import { debounce } from "lodash";
import React, { useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useSupplierModel } from "../supplierModel";
export const BaseSupplierDetails = ({ modeKey, mode, rowId, dispatch }) => {
    const { t } = useTranslation();
    const {
        addFormVal,
        editFormVal,
        lookFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertSupplier,
        editSupplier,
        getSupplierOne,
        setAddFormVal,
        setSelectedRowKeys,setSaveBtnLoading,saveBtnLoading
    } = useSupplierModel()
    const {
        user: { shopName },
    } = useGlobalModel()
    const { getTreeSelectOne } = useDictModel()
    const formRef = useRef()
    const updateFormVal = mode === 'add' ? updateAddFormVal : updateEditFormVal

    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
        if (mode === "edit" || mode === "look") {
            getSupplierOne(rowId, mode)
        }
        return () => {
            updateFormVal(null)
        }
    }, [rowId, mode])

    //关闭当前页
    const onClose = () => {
        dispatch({
            type: "removeTabs",
            targetKey: modeKey,
            activeMenu: "baseSupplier",
        })
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current
            .validateFields()
            .then((res) => {
                let data = {
                    ...res,
                }
                if (mode === "edit") {
                    editSupplier({ ...data, id: rowId }).then((res) => {
                        res && onClose()
                    })
                } else {
                    insertSupplier(data).then((res) => {
                        setSelectedRowKeys([res])
                        res && onClose()
                    })
                }
            })
            .catch((err) => {
                setSaveBtnLoading(false)
                message.warning(getFormValidatorErrText(err))
            })
    }

    // 基础信息
    const baseFormItem = {
        title: t(`base.view.detailsBox.基础信息`),
        style: { padding: "0 20px", marginBottom: "10px" },
        items: [
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.供应商编码`),
                fieldName: "code",
                disable: true,
                placeholder: t(`base.view.detailsBox.自动生成`),
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.供应商名称`),
                fieldName: "name",
                rules: [{ required: true, message: t(`base.view.detailsBox.请输入供应商名称`) }],
            },
            {
                type: "TreeSelect",
                fieldLabel: t(`base.view.detailsBox.供应商类型`),
                fieldName: "categoryCode",
                treeData: getTreeSelectOne(DictCodeEnmu.SUPPLIER_TYPE),
                rules: [{ required: true, message: t(`base.view.detailsBox.请选择供应商类型`) }],
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.联系人`),
                fieldName: "contact",
                rules: [{ required: true, message: t(`base.view.detailsBox.请输入联系人`) }]
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.联系电话`),
                fieldName: "phone",
                rules: [{ required: true, message: t(`base.view.detailsBox.请输入联系人电话`) }]
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.职务`),
                fieldName: "position",
            },
            {
                type: "Input",
                fieldLabel: `${t(`base.view.detailsBox.联系人`)}2`,
                fieldName: "name2",
            },
            {
                type: "Input",
                fieldLabel: `${t(`base.view.detailsBox.联系电话`)}2`,
                fieldName: "phone2",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.办公电话`),
                fieldName: "tel",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.电子邮箱`),
                fieldName: "email",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.邮编`),
                fieldName: "postCode",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.所属门店`),
                fieldName: "shopName",
                disabled: true,
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.传真号码`),
                fieldName: "fax",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.联系地址`),
                fieldName: "address",
                rules: [{ required: true, message: t(`base.view.detailsBox.联系地址`) }],
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.备注`),
                fieldName: "note",
                span: 12,
            },
            {
                type: "Switch",
                fieldLabel: t(`base.view.detailsBox.状态`),
                fieldName: "enable",
            },
            {
                type: "Checkbox",
                fieldLabel: t(`base.view.detailsBox.客户`),
                fieldName: "isTransfer",
                hidden: mode !== "add"
            },
        ],
    }
    const makeFormItem = {
        title: t(`base.view.detailsBox.开票信息`),
        style: { padding: "0 20px", marginBottom: "10px" },
        items: [
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.发票抬头`),
                fieldName: "invoiceTitle",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.营业执照`),
                fieldName: "licenseNo",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.开户银行`),
                fieldName: "bank",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.银行账号`),
                fieldName: "bankAcct",
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.邮寄地址`),
                fieldName: "postAddress",
                span: 12,
            },
        ],
    }
    const otherFormItem = {
        title: t(`base.view.detailsBox.其它信息`),
        style: { padding: "0 20px", marginBottom: "10px" },
        items: [
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.创建人`),
                fieldName: "createUser",
                disable: true,
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.创建时间`),
                fieldName: "createTime",
                disable: true,
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.修改人`),
                fieldName: "updateUser",
                disable: true,
            },
            {
                type: "Input",
                fieldLabel: t(`base.view.detailsBox.修改时间`),
                fieldName: "updateTime",
                disable: true,
            },
        ],
    }

    const onChange = (changedValues) => {
        // console.log(changedValues);
        mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues)
    }
    const typeForm = {
        add: addFormVal,
        edit: editFormVal,
        look: lookFormVal,
    }

    const typeTitle = {
        add: t(`base.view.detailsBox.新增`),
        edit: t(`base.view.detailsBox.编辑`),
        look: t(`base.view.detailsBox.查看`),
    }

    const supplierFromConfig = {
        formRef,
        disabled: mode === "look",
        labelAlign: "right",
        formValues: { ...typeForm[mode], shopName },
        onChange,
        boxs: [baseFormItem, makeFormItem, otherFormItem],
    }
    const reset = () => {
        formRef.current.resetFields()
        if (mode === "add") {
            setAddFormVal({})
        } else if (mode === "edit") {
            getSupplierOne(rowId, mode)
        }
        message.success(t(`base.view.detailsBox.重置成功`))
    }
    const action = (
        <>
            {mode !== "look" && (
                <Button
                    className="btn-item"
                    shape="round"
                    loading={saveBtnLoading}
                    onClick={debounce(() => {
                        onSubmit()
                    }, 900)}
                >
                   {saveBtnLoading ? t(`base.view.detailsBox.保存中`) : t(`base.view.detailsBox.保存`)}
                </Button>
            )}
            {mode !== "look" && (
                <Button className="btn-item" shape="round" onClick={() => reset()}>
                     {t(`base.view.detailsBox.重置`)}
                </Button>
            )}
            <Button className="btn-item" shape="round" onClick={onClose}>
                 {t(`base.view.detailsBox.取消`)}
            </Button>
        </>
    )

    return (
        <>
            <YhBox title={`${t(`base.view.detailsBox.供应商`)}${typeTitle[mode]}`} action={action} style={{ padding: "0 20px", marginBottom: "10px" }}></YhBox>
            <YhFormBox {...supplierFromConfig} />
        </>
    )
}
